var _path, _ellipse, _ellipse2, _g, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInternetshoping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.9959 52.4078C99.9959 56.9905 99.3506 61.4226 98.1459 65.6184C97.6206 67.4481 96.9888 69.2329 96.2578 70.9656M31.6885 9.17737C21.8079 13.8549 13.787 21.8149 9.03619 31.6482M5.17236 43.2861C5.56701 41.2448 6.09161 39.2497 6.73722 37.3099",
    stroke: "white",
    strokeWidth: 1.04007,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 52,
    rx: 52,
    ry: 52,
    fill: "#060C23"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_910_205126",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 104,
    height: 104
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 52,
    rx: 52,
    ry: 52,
    fill: "#060C23"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_910_205126)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.4422,
    cy: 57.8824,
    rx: 32.9104,
    ry: 32.9104,
    fill: "#2E293D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7729 104.295C58.9018 106.053 64.4355 107 70.1717 107C76.4478 107 82.3865 105.85 87.9202 103.822V97.2629H53.7729V104.295Z",
    fill: "#451F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2248 68.343C43.8322 70.5744 46.1941 71.9268 48.4211 71.2506L56.9242 68.884C59.1512 68.2754 60.5009 65.9088 59.826 63.6774C59.2187 61.446 56.8567 60.0936 54.6297 60.7698L46.1941 63.204C43.9671 63.8126 42.6174 66.1116 43.2248 68.343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2844 59.748C43.8918 61.9794 46.2538 63.3318 48.4807 62.6556L56.9838 60.289C59.2108 59.6804 60.5605 57.3138 59.8857 55.0824C59.2783 52.851 56.9163 51.4986 54.6893 52.1748L46.4562 54.5414C44.2292 55.15 42.6771 57.5166 43.2844 59.748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1102 51.0797C43.7851 53.4463 46.1471 54.7987 48.4415 54.1225L57.2145 51.6882C59.509 51.012 60.8587 48.6454 60.2513 46.2787C59.5765 43.9121 57.2145 42.5597 54.9201 43.2359L46.1471 45.6702C43.7851 46.3464 42.4354 48.7806 43.1102 51.0797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6816 38.654C42.2092 40.953 43.7614 43.1844 45.9884 43.5901L56.5835 45.6863C58.8779 46.1596 61.1049 44.6044 61.5098 42.373C61.9822 40.0739 60.4301 37.8425 58.2031 37.4368L47.608 35.3407C45.3135 34.8673 43.0865 36.3549 42.6816 38.654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3802 78.3822C87.3802 80.2835 86.0305 81.8452 84.2759 81.8452H54.0428C52.3557 81.8452 50.9385 80.2835 50.9385 78.3822V20.4629C50.9385 18.5617 52.2882 17 54.0428 17H84.2759C85.963 17 87.3802 18.5617 87.3802 20.4629V78.3822Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4231 59.1262L95.2084 54.7987L93.5213 46.1435C93.3188 43.9797 92.779 42.6274 92.509 41.6807C92.1716 40.396 91.8342 40.5312 91.4968 40.3283C90.8219 39.855 90.2146 40.0579 90.2146 40.0579C87.5152 40.0579 85.4231 43.7769 85.963 50.2006C85.963 50.2006 86.4354 52.0263 86.9753 55.4072C87.2452 56.9624 87.3802 61.5605 87.3802 61.5605C87.3802 62.6424 87.4477 72.1766 87.4477 76.8422C87.4477 82.5222 85.5581 81.7107 75.5704 81.7107H54.3802C54.3802 81.7107 53.5704 83.6041 56.6072 85.2945V92.3268H83.871L83.3986 85.6326C84.5458 85.9707 89.9446 74.0699 96.4231 59.1262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M85.1532 93.882H57.0796V97.2629H85.1532V93.882Z",
    fill: "#352E3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4233 90.2195H54.4233V93H87.4233V90.2195Z",
    fill: "#435CDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M73.6806 19.7047C73.6806 19.9752 73.4781 20.1781 73.1407 20.1781H64.8401C64.5701 20.1781 64.3677 19.9752 64.3677 19.7047C64.3677 19.4343 64.5701 19.2314 64.9076 19.2314H73.2082C73.4781 19.2314 73.6806 19.4343 73.6806 19.7047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4106 21.9424H53.8091V71.2299H84.4106V21.9424Z",
    fill: "#435CDB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.1104 22.0038H53.7729V71.1623H54.1104V22.0038Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8017 54.2594L48.0962 56.8966C50.3906 58.5194 53.2925 58.4518 54.5747 56.6261C55.8569 54.8004 55.0471 52.028 52.7526 50.3376L48.0962 45.9424C46.8814 46.1452 45.0594 46.0776 43.7771 47.9033C43.8446 47.9033 41.2802 51.8928 45.8017 54.2594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5114 62.8585L47.7383 65.428C49.9653 67.0508 52.8672 66.848 54.1494 65.0223C55.4316 63.1966 54.6893 60.4242 52.4623 58.8014L47.4684 54.2033C46.2537 54.271 44.9715 54.609 43.6893 56.5024C43.6218 56.5024 41.7322 60.2214 45.5114 62.8585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4233 93.4783C52.4233 92.6957 52.8858 92 53.5466 92H88.3001C88.8948 92 89.4233 92.6087 89.4233 93.4783V104.522C89.4233 105.304 88.9608 106 88.3001 106H53.5466C52.9519 106 52.4233 105.391 52.4233 104.522V93.4783Z",
    fill: "#22FFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8445 70.3716L48.8689 73.8816C50.6235 75.1664 53.0529 74.8283 54.2677 73.1378C55.4824 71.4474 55.01 69.0807 53.2554 67.796L47.2065 63.0012C46.1267 63.2041 44.912 63.2717 43.6973 64.9622C43.6973 64.9622 41.8752 68.3431 44.8445 70.3716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0846 48.2922C74.6734 46.4187 73.4986 44.1959 73.4986 42.767C73.4986 41.8779 74.9965 36.829 75.0259 36.702C75.1728 36.2574 75.0553 34.6062 75.0553 34.6062C75.0553 34.6062 75.5252 31.8436 75.2609 30.6052C75.1728 30.5735 74.6441 30.3512 74.5266 30.3194C74.5266 30.3194 74.0273 32.0659 74.0273 34.5427C74.0273 34.5427 70.532 35.2731 69.5921 36.2257C68.6816 35.2731 65.157 34.5427 65.157 34.5427C65.1864 32.0659 64.687 30.3194 64.687 30.3194C64.5402 30.3829 64.0409 30.5735 63.9527 30.6052C63.6884 31.8436 64.1583 34.6062 64.1583 34.6062C64.1583 34.6062 64.0409 36.2257 64.1877 36.702C64.2465 36.8608 65.715 41.8779 65.715 42.767C65.715 44.1959 64.5402 46.4187 64.129 48.2922C63.6884 50.2927 64.7164 62.0734 64.9808 64.5185L67.4186 64.709C68.8872 64.8043 70.3558 64.8043 71.8244 64.709L74.2622 64.5185C74.4972 62.0734 75.5252 50.2609 75.0846 48.2922Z",
    fill: "#22FFAA"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3145 8.4021C30.8793 10.4825 25.2194 13.8502 20.5276 18.1281M16.4353 22.374C15.126 23.9204 13.923 25.5489 12.8328 27.2468C12.0223 28.5092 11.2741 29.8099 10.5908 31.1439",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5132,
    y: 25.3837,
    width: 17.9291,
    height: 17.9291,
    fill: "#22FFAA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5132,
    y: 46.8514,
    width: 17.9291,
    height: 17.9291,
    fill: "#47FFB9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5132,
    y: 68.3191,
    width: 17.9291,
    height: 17.9291,
    fill: "#85FFD0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4424,
    y: 25.3837,
    width: 45.8112,
    height: 1.34278,
    fill: "#22FFAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3263 39.9839C28.5049 39.9839 27.7909 39.8486 27.1843 39.5779C26.5776 39.3073 26.0876 38.9386 25.7143 38.4719L26.9323 37.1279C27.2869 37.5199 27.6743 37.8093 28.0943 37.9959C28.5236 38.1826 28.9576 38.2759 29.3963 38.2759C29.9003 38.2759 30.2829 38.1639 30.5443 37.9399C30.8056 37.7159 30.9363 37.3939 30.9363 36.9739C30.9363 36.6286 30.8336 36.3673 30.6283 36.1899C30.4323 36.0126 30.0963 35.8866 29.6203 35.8119L28.5983 35.6439C27.7209 35.4946 27.0863 35.1726 26.6943 34.6779C26.3023 34.1739 26.1063 33.5626 26.1063 32.8439C26.1063 31.9013 26.4143 31.1733 27.0303 30.6599C27.6463 30.1373 28.5096 29.8759 29.6203 29.8759C30.3763 29.8759 31.0343 29.9926 31.5943 30.2259C32.1543 30.4593 32.6069 30.7766 32.9523 31.1779L31.7623 32.5079C31.5009 32.2186 31.1929 31.9946 30.8383 31.8359C30.4836 31.6679 30.0823 31.5839 29.6343 31.5839C28.6916 31.5839 28.2203 31.9713 28.2203 32.7459C28.2203 33.0819 28.3229 33.3339 28.5283 33.5019C28.7429 33.6699 29.0883 33.7959 29.5643 33.8799L30.5863 34.0619C31.3796 34.2019 31.9909 34.5006 32.4203 34.9579C32.8496 35.4153 33.0643 36.0313 33.0643 36.8059C33.0643 37.2633 32.9849 37.6879 32.8263 38.0799C32.6676 38.4626 32.4296 38.7986 32.1123 39.0879C31.7949 39.3679 31.4029 39.5873 30.9363 39.7459C30.4789 39.9046 29.9423 39.9839 29.3263 39.9839Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3143 56.4619L31.4263 53.7319H31.3003L29.4803 58.7579L27.6603 53.7319H27.5343L27.6463 56.4619V60.8159H25.8263V51.0439H28.3043L29.5083 54.3339H29.6203L30.8243 51.0439H33.1343V60.8159H31.3143V56.4619Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5683 81.8159V72.0439H28.6823V80.0939H32.8823V81.8159H26.5683Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetshoping);
export default __webpack_public_path__ + "static/media/internet shoping.9112ecfdf88ac4a83bd1d952ecbbc0d4.svg";
export { ForwardRef as ReactComponent };